import { AddUser } from './../../../_models/AddUser';
import { ToasterService } from './../../../_services/Toaster.service';
import { _userServicesService } from './../../../_services/_UserService/_userServices.service';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PreloaderService } from 'src/app/_services/Preloader.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-AddUser',
  templateUrl: './AddUser.component.html',
  styleUrls: ['./AddUser.component.css'],
})
export class AddUserComponent implements OnInit {
  @Input() DeviceIDFromHome: any;
  @Output() cancelAddUser = new EventEmitter();
  LastUserIndex: string;
  model: any = {};
  selectedCheckbox: any;

  constructor(
    private spinner: NgxSpinnerService,
    private preloader: PreloaderService,
    private UserService: _userServicesService,
    private notiService: ToasterService
  ) {}

  ngOnInit() {
    if (this.DeviceIDFromHome != undefined) {
      if (this.DeviceIDFromHome != 'Select Device') {
        this.GetLastUserIndex(this.DeviceIDFromHome);
      } else {
        this.notiService.warning('Select Device First', 'Error');
      }
    } else {
      this.notiService.warning('Select Device First', 'Error');
    }
  }
  selectChangeHandler(event: any) {
    this.selectedCheckbox = event.target.value;
  }
  CancelAddUser() {
    this.cancelAddUser.emit(false);
  }

  GetLastUserIndex(DeviceID) {
    // tslint:disable-next-line: no-shadowed-variable
    this.UserService.GetLastUserIndex(DeviceID).subscribe((Response) => {
      if (Response.status == 200) {
        this.LastUserIndex = Response.body;
      }
    });
  }

  AddUser() {
    if (this.DeviceIDFromHome == null || this.DeviceIDFromHome == '') {
      this.notiService.error('Error', 'Select Device First');
    }
    if (this.model.UserID == undefined) {
      return this.notiService.error('Error', 'User ID not defined');
    }
    if (this.model.Username == undefined) {
      return this.notiService.error('Error', 'User name not defined');
    }
    if (this.selectedCheckbox == undefined) {
      return this.notiService.error('Error', 'Enroll  not defined');
    }
    this.spinner.show();
    this.model.Mode = this.selectedCheckbox;
    this.model.DevID = this.DeviceIDFromHome;
    this.UserService.AddUser(this.model).subscribe(
      (Response) => {
        this.spinner.hide();
        if (Response.status == 200) {
          this.notiService.success('Success', Response.body);
        } else {
          this.notiService.error('Error', Response.body);
        }
      },
      (error) => {
        this.spinner.hide();
        if (error.status == 400) {
          this.notiService.error('Error', error.error);
        } else {
          this.notiService.error('Something Went Wrong', error);
        }
      }
    );
  }
}
